import { useEffect } from "react";
import { useAppDispatch, actions } from "store";
export var KeyBindings;
(function (KeyBindings) {
    KeyBindings["DELETE"] = "Delete";
    KeyBindings["ESCAPE"] = "Escape";
})(KeyBindings || (KeyBindings = {}));
var noIds = [];
/* The Delete key also deletes forwards in a text field. */
var isTyping = function (target) {
    return target instanceof HTMLElement &&
        (target.isContentEditable ||
            ["INPUT", "TEXTAREA", "SELECT"].includes(target.tagName));
};
export var useKeyBindings = function (_a) {
    var keys = _a.keys, disabled = _a.disabled, _b = _a.nodeIds, nodeIds = _b === void 0 ? noIds : _b, _c = _a.edgeIds, edgeIds = _c === void 0 ? noIds : _c;
    var dispatch = useAppDispatch();
    useEffect(function () {
        if (disabled)
            return;
        var handleDelAndEscKeys = function (event) {
            var shouldDelete = keys.includes(KeyBindings.DELETE) &&
                event.key === "Delete" &&
                (nodeIds.length > 0 || edgeIds.length > 0) &&
                !isTyping(event.target);
            var shouldDeselect = keys.includes(KeyBindings.ESCAPE) && event.key === "Escape";
            if (shouldDelete) {
                dispatch(actions.deleteEntities({ nodeIds: nodeIds, edgeIds: edgeIds }));
            }
            else if (shouldDeselect) {
                dispatch(actions.deselectEntities());
            }
        };
        window.addEventListener("keydown", handleDelAndEscKeys);
        return function () {
            window.removeEventListener("keydown", handleDelAndEscKeys);
        };
    }, [disabled, dispatch, edgeIds, keys, nodeIds]);
};
